function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/Menu',['iScroll'], function (IScroll) {
  'use strict';

  /**
   * Menu class.
   * 
   * @author Kai Schonehoff <ks@sopg.de>
   * @author Lennart Bergmann <lb@sopg.de>
   * @jira CHEF-220
   * 
   * @created 2021-02-24
   * @updated 2021-03-16
   * 
   * @type Menu
   */
  var Menu = /*#__PURE__*/_createClass(
  /**
   * Constructor.
   * 
   * @author Kai Schonehoff <ks@sopg.de>
   * @created 2021-02-24
   * @updated 2021-03-16
   * 
   * @returns {undefined}
   */
  function Menu() {
    var _this = this;
    _classCallCheck(this, Menu);
    /**
     * Init.
     * 
     * @author Kai Schoenhoff <ks@sopg.de>
     * @created 2021-02-24
     * @updated 2021-03-16
     * 
     * @returns {this}
     */
    _defineProperty(this, "init", function () {
      _this.menuToggle();
      _this.menuLink();
      _this.languageSwitch();
      _this.initIscroll();
      return _this;
    });
    /**
     * Toggle Menu.
     * 
     * @author Kai Schoenhoff <ks@sopg.de>
     * @created 2021-02-24
     * 
     * @returns {this}
     */
    _defineProperty(this, "menuToggle", function () {
      var bOpen = false;
      _this.$menuToggler.on("click", function () {
        window.fullpage.setAllowScrolling(bOpen);
        bOpen = !bOpen;
        _this.$menuContainer.toggleClass(_this.o.opts.classes.open);
      });
      _this.$menuClose.on("click", function () {
        window.fullpage.setAllowScrolling(bOpen);
        bOpen = !bOpen;
        _this.$menuContainer.toggleClass(_this.o.opts.classes.open);
      });
    });
    /**
     * Close Menu after click on menu-link.
     * 
     * @author Kai Schoenhoff <ks@sopg.de>
     * @created 2021-02-25
     * 
     * @returns {this}
     */
    _defineProperty(this, "menuLink", function () {
      _this.$menuLink.on("click", function () {
        _this.$menuContainer.removeClass(_this.o.opts.classes.open);
      });
    });
    /**
     * Init language switch.
     * 
     * @author Kai Schoenhoff <ks@sopg.de>
     * @created 2021-02-24
     * 
     * @returns {this}
     */
    _defineProperty(this, "languageSwitch", function () {
      _this.$languageSwitch.on("click", function (event) {
        if (event.target.href && $(_this.o.sel.activeSlide).attr(_this.o.opts.attr.slideSlug)) {
          window.location.href = event.target.href + '/' + $(_this.o.sel.activeSlide).attr(_this.o.opts.attr.slideSlug) + '/';
          event.preventDefault();
        }
      });
    });
    /**
     * Init iscroll.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-03-16
     * 
     * @returns {Menu}
     */
    _defineProperty(this, "initIscroll", function () {
      var oScrollContainer = document.querySelector(_this.o.sel.scrollContainer);
      if (null === oScrollContainer || 0 === oScrollContainer.children.length) {
        return _this;
      }
      var oIScroll = new IScroll(oScrollContainer, {
        mouseWheel: true,
        scrollbars: true,
        scrollX: false,
        scrollY: true,
        preventDefault: false,
        probeType: 0
      });
      return _this;
    });
    this.o = {
      sel: {
        menuContainer: 'html',
        menuContent: '#menu-content',
        menuToggler: '#menu-button',
        menuClose: '.menu-close',
        languageSwitch: '.js-language-switch',
        activeSlide: '.slide.active',
        menuLink: 'a',
        scrollContainer: '.js-menu-scroll-container'
      },
      opts: {
        attr: {
          slideSlug: 'data-key'
        },
        classes: {
          open: 'menu-open',
          active: 'hide',
          completed: 'completed'
        }
      }
    };
    this.$menuToggler = $(this.o.sel.menuToggler);
    this.$menuClose = $(this.o.sel.menuClose);
    this.$menuContainer = $(this.o.sel.menuContainer);
    this.$menuLink = $(this.o.sel.menuLink);
    this.$languageSwitch = $(this.o.sel.languageSwitch);
    this.init();
  });
  return Menu;
});

